function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import cloneDeep from 'lodash/cloneDeep';
import pathOr from 'ramda/src/pathOr';
import isNil from 'ramda/src/isNil';
import i18n from 'invision-core/src/components/i18n/i18n';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { getCodeTablePropertyValueByName, getDependentAttributes, getIsRequired, getPossibleValues, getRegexValidation, showHideAttributes } from './attribute.modal.helper';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { SERVICE_ATTRIBUTE_DISPLAY_TYPES, NOTIFICATION_TIME_LENGTH } from '../../../../../customercare.constants';
import { CurrentOrderServiceIdentifiersSelector, IsUpdatingOrderServiceDetailsSelector, UpdateOrderServiceDetailsErrorSelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { IsRetrievingInventory, RetrieveInventoryError } from '../../../../../reducers/selectors/order.history.selectors';
import { retrieveOrderServiceDetails, searchInventoryForUpdatingAttributes, updateOrderServiceDetails } from '../../../../../reducers/actions/order.actions';
var AttributeModalController = /*#__PURE__*/function () {
  function AttributeModalController($ngRedux, uiNotificationService) {
    _classCallCheck(this, AttributeModalController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      uiNotificationService: uiNotificationService,
      SERVICE_ATTRIBUTE_DISPLAY_TYPES: SERVICE_ATTRIBUTE_DISPLAY_TYPES
    });
    this.formOptions = {
      debounce: 300
    };
    this.formFieldLocaleKeyMapping = {};
  }
  return _createClass(AttributeModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentOrderServiceIdentifiers: CurrentOrderServiceIdentifiersSelector(store),
          isUpdatingOrderServiceDetails: IsUpdatingOrderServiceDetailsSelector(store),
          isRetrievingInventory: IsRetrievingInventory(store),
          retrieveInventoryError: RetrieveInventoryError(store),
          updateOrderServiceDetailsError: UpdateOrderServiceDetailsErrorSelector(store)
        };
      };
      var controllerActions = {
        retrieveOrderServiceDetails: retrieveOrderServiceDetails,
        searchInventoryForUpdatingAttributes: searchInventoryForUpdatingAttributes,
        updateOrderServiceDetails: updateOrderServiceDetails
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.duplicateServiceIdentifiers = [];
      this.attributes = this.editAttributes.asMutable({
        deep: true
      }).concat(this.availableAttributes.asMutable({
        deep: true
      }));
      this.buildPossibleValues();
      this.setAttributeVisibility();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnect();
    }
  }, {
    key: "buildPossibleValues",
    value: function buildPossibleValues() {
      var _this2 = this;
      this.attributes.forEach(function (attribute) {
        attribute.isRequired = getIsRequired(attribute, _this2.attributeConfiguration);
        attribute.PreviousValue = cloneDeep(attribute.Value);
        attribute.possibleValues = getPossibleValues(attribute, _this2.attributeConfiguration);
        attribute.regularExpression = getRegexValidation(attribute, _this2.attributeConfiguration, _this2.regexCodes);
        attribute.serviceAttributeDisplayType = getCodeTablePropertyValueByName(attribute, _this2.attributeConfiguration, 'service_attribute_display_type_code');
        attribute.validationError = i18n.translate(CoreLocaleKeys.FIELD_IS_INVALID, {
          field_name: attribute.ServiceAttributeName
        });
        _this2.formFieldLocaleKeyMapping[attribute.ServiceAttributeId] = attribute.validationError;
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.onClose()();
    }
  }, {
    key: "hideForm",
    value: function hideForm() {
      return this.attributes.every(function (attr) {
        return !attr.Editable;
      });
    }
  }, {
    key: "update",
    value: function update() {
      var _this3 = this;
      this.duplicateServiceIdentifiers = [];
      var orderItems = [{
        AddedServiceAttributesValues: [],
        ModifiedServiceAttributeValues: [],
        OrderItemId: this.orderItemId
      }];
      this.attributes.forEach(function (attribute) {
        var duplicatedServiceIdentifier = _this3.state.currentOrderServiceIdentifiers.find(function (attr) {
          return attribute.IsServiceIdentifier && attr.Value === attribute.Value && attr.ServiceAttributeId !== attribute.ServiceAttributeId;
        });
        if (duplicatedServiceIdentifier) {
          _this3.duplicateServiceIdentifiers.push(attribute.ServiceAttributeId);
        } else {
          if (attribute.Editable) {
            var editAttribute = _this3.editAttributes.find(function (attr) {
              return attr.ServiceAttributeId === attribute.ServiceAttributeId;
            });
            if (!!editAttribute && attribute.PreviousValue !== attribute.Value) {
              orderItems[0].ModifiedServiceAttributeValues.push(attribute);
            } else if (!editAttribute && !isNil(attribute.Value)) {
              orderItems[0].AddedServiceAttributesValues.push(attribute);
            }
          }
        }
      });
      if (!this.duplicateServiceIdentifiers.length) {
        this.actions.updateOrderServiceDetails(this.orderId, orderItems).then(function () {
          _this3.actions.retrieveOrderServiceDetails(_this3.orderId, _this3.customerId);
          _this3.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.SERVICE_ATTRIBUTES.UPDATE_SUCCESS), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
          _this3.onClose()();
        });
      }
    }
  }, {
    key: "setAttributeVisibility",
    value: function setAttributeVisibility() {
      var dependentAttributes = getDependentAttributes(this.attributes, this.attributeConfiguration);
      if (dependentAttributes.length) {
        showHideAttributes(dependentAttributes, this.attributes, this.attributeConfiguration);
      }
    }
  }, {
    key: "getMoreOptions",
    value: function getMoreOptions(attr) {
      this.hasSearchedForInventory = true;
      this.actions.searchInventoryForUpdatingAttributes(attr.InventoryTypeId).then(function (response) {
        attr.inventoryOptions = response.InventoryItems;
      }).catch(function () {});
    }
  }, {
    key: "setRadioValue",
    value: function setRadioValue(attr, inventoryOption) {
      attr.Value = inventoryOption.SerialNumber;
    }
  }, {
    key: "attributesDuplicated",
    value: function attributesDuplicated() {
      return this.duplicateServiceIdentifiers.length ? this.duplicateServiceIdentifiers : pathOr([], ['faultData'], this.state.updateOrderServiceDetailsError);
    }
  }, {
    key: "getServiceIdentifierDuplicatedErrorMessage",
    value: function getServiceIdentifierDuplicatedErrorMessage() {
      return i18n.translate(CustomerCareLocaleKeys.SERVICE_IDENTIFIER_DUPLICATES_FOUND, {
        duplicates: this.attributesDuplicated().length
      });
    }
  }, {
    key: "isAttributeDuplicated",
    value: function isAttributeDuplicated(id) {
      if (this.attributesDuplicated().includes(id)) {
        return this.editAttributesForm.$submitted;
      }
    }
  }, {
    key: "getAttributeDuplicatedErrorMessage",
    value: function getAttributeDuplicatedErrorMessage() {
      return i18n.translate(this.duplicateServiceIdentifiers.length ? CustomerCareLocaleKeys.SERVICE_IDENTIFIER_UNIQUE_ERROR : CustomerCareLocaleKeys.SERVICE_IDENTIFIER_ALREADY_EXISTS);
    }
  }, {
    key: "showUpdateOrderServiceDetailsError",
    value: function showUpdateOrderServiceDetailsError() {
      return pathOr('', ['message'], this.state.updateOrderServiceDetailsError) && !this.attributesDuplicated().length && this.editAttributesForm.$submitted;
    }
  }, {
    key: "setServiceAttributeDisplayTypeVisibility",
    value: function setServiceAttributeDisplayTypeVisibility(attr) {
      if (this.isOpenOrder && attr.Editable) {
        return this.SERVICE_ATTRIBUTE_DISPLAY_TYPES.EDITABLE;
      } else if (this.isOpenOrder && !attr.Editable) {
        return this.SERVICE_ATTRIBUTE_DISPLAY_TYPES.VIEWABLE;
      } else if (!this.isOpenOrder && attr.Editable && attr.serviceAttributeDisplayType === this.SERVICE_ATTRIBUTE_DISPLAY_TYPES.EDITABLE) {
        return this.SERVICE_ATTRIBUTE_DISPLAY_TYPES.VIEWABLE;
      } else if (!this.isOpenOrder && (!attr.Editable || attr.serviceAttributeDisplayType === this.SERVICE_ATTRIBUTE_DISPLAY_TYPES.VIEWABLE)) {
        return this.SERVICE_ATTRIBUTE_DISPLAY_TYPES.VIEWABLE;
      }
    }
  }]);
}();
export default {
  controller: AttributeModalController,
  controllerAs: 'AttributeModal',
  template: require('./attribute.modal.html'),
  bindings: {
    attributeConfiguration: '<',
    availableAttributes: '<',
    contentTitle: '<',
    customerId: '<',
    dialogTitle: '<',
    editAttributes: '<',
    onClose: '&',
    orderId: '<',
    orderItemId: '<',
    regexCodes: '<',
    isOpenOrder: '<'
  }
};